import React, { useEffect, useRef, useState } from "react";
import { Container, HeaderMenu, Logo, Status, Title } from "./styels";
import { generateThumbnail } from "../../functions/string";
import ProfileBar from "../profile";
import { logo } from "../../../../images";
import { GetIcon } from "../../../../icons";
const Header = (props) => {
  const [isProfileBarOpen, setIsProfileBarOpen] = useState(false);
  const profileRef = useRef(null);

  // Function to handle clicks outside of the Profile component
  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileBarOpen(false);
    }
  };

  // Add a click event listener when the component mounts
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Toggle the ProfileBar when clicking the Profile
  const handleProfileClick = () => {
    setIsProfileBarOpen(!isProfileBarOpen);
  };
  // const navigate = useNavigate();
  return (
    <Container>
      {/* <MNav
        className="navicon"
        onClick={() => {
          dispatch(menuStatus(!menuCurrentStatus));
        }}
      >
        <GetIcon icon={"menu"} />
      </MNav> */}

      <Status>
        {/* <MNav>
          <GetIcon icon={selectedMenuItem.icon} />
        </MNav> */}
        <Title>
          <Logo src={logo} alt="logo" />
        </Title>
        {/* <User>{props.user.user.email}</User> */}
        <HeaderMenu
          ref={profileRef}
          onClick={() => {
            handleProfileClick();
          }}
        >
          {generateThumbnail(
            props.user.user?.fullName ?? props.user.user?.username ?? "",
            null,
            props.user.user.photo ?? ""
          )}
          <i>{props.user.user?.fullName ?? props.user.user?.username}</i>
          <GetIcon icon={"down-small"}></GetIcon>
          {isProfileBarOpen && (
            <div className="ProfileBar" onClick={(e) => e.stopPropagation()}>
              <ProfileBar
                close={() => setIsProfileBarOpen(false)}
                setLoaderBox={props.setLoaderBox}
                setMessage={props.setMessage}
                data={props.user}
              ></ProfileBar>
            </div>
          )}
        </HeaderMenu>
      </Status>
    </Container>
  );
};

export default Header;
